import React from "react";
import ConfirmDialog from "./ConfirmDialog";

const DeleteModal = ({ isOpen, closeModal, handleDeleteAction, itemId }) => {
  return (
    <ConfirmDialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) closeModal();
      }}
      title="Delete item?"
      description="This item will be permanently deleted."
      confirmLabel="Delete"
      variant="destructive"
      onConfirm={() => {
        handleDeleteAction(itemId);
        closeModal();
      }}
    />
  );
};

export default DeleteModal;
